import { render, staticRenderFns } from "./NotificationsDropdownMenu.vue?vue&type=template&id=3717bf04&scoped=true&"
import script from "./NotificationsDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDropdownMenu.vue?vue&type=style&index=0&id=3717bf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3717bf04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VList,VRow})
